import type React from "react";

interface DonationFrequencySectionProps {
	recurring: boolean;
	onRecurringChange: (recurring: boolean) => void;
	hasActiveSubscription?: boolean;
}

export const DonationFrequencySection: React.FC<
	DonationFrequencySectionProps
> = ({ recurring, onRecurringChange, hasActiveSubscription = false }) => {
	return (
		<section id="donation-frequency-section">
			<h2 className="text-lg">I would like to give</h2>

			<div className="radio-group flex gap-2 mb-4">
				<input
					type="radio"
					id="donation-frequency-section--one-time"
					name="donation-frequency-section--frequency"
					value="false"
					checked={!recurring}
					onChange={() => onRecurringChange(false)}
				/>
				<label
					htmlFor="donation-frequency-section--one-time"
					className="rounded-full text-brand"
				>
					One time
				</label>

				<input
					type="radio"
					id="donation-frequency-section--monthly"
					name="donation-frequency-section--frequency"
					value="true"
					checked={recurring}
					disabled={hasActiveSubscription}
					aria-describedby={
						hasActiveSubscription ? "monthly-disabled-tooltip" : undefined
					}
					onChange={() => onRecurringChange(true)}
				/>
				<label
					htmlFor="donation-frequency-section--monthly"
					className="rounded-full text-brand"
					style={{
						position: "relative",
						opacity: hasActiveSubscription ? 0.5 : 1,
						cursor: hasActiveSubscription ? "not-allowed" : "pointer",
					}}
				>
					Monthly
					{hasActiveSubscription && (
						<span
							role="tooltip"
							id="monthly-disabled-tooltip"
							className="monthly-tooltip"
						>
							You already have an active monthly donation. Please cancel it in
							your account settings before starting a new one.
						</span>
					)}
				</label>
			</div>

			<div className="speech-bubble">Giving regularly has a greater impact</div>
		</section>
	);
};
